import type {
  FinalizeCertRequestBody,
  SoftwareProfile,
} from "@/lib/api/cert-requests";

export function emptyFinalizeCertRequestBody(
  nit: string,
): FinalizeCertRequestBody {
  return {
    softwareInvoice: { softwareId: "", softwarePin: "", testSetId: "" },
    softwarePos: { softwareId: "", softwarePin: "", testSetId: "" },
    softwarePayroll: { softwareId: "", softwarePin: "", testSetId: "" },
    alias: `pahfacturar-${nit}`,
  };
}

function normalizeSoftwareProfile(profile: SoftwareProfile): SoftwareProfile {
  const testSetId = profile.testSetId?.trim();
  return {
    softwareId: profile.softwareId.trim(),
    softwarePin: profile.softwarePin.trim(),
    ...(testSetId ? { testSetId } : {}),
  };
}

/**
 * Produces the exact admin finalize contract without merging profile objects.
 * Empty optional TestSetIds are omitted because dian-types rejects an empty
 * string, and each profile is normalized independently so POS data cannot
 * overwrite invoice or payroll credentials.
 */
export function normalizeFinalizeCertRequestBody(
  body: FinalizeCertRequestBody,
): FinalizeCertRequestBody {
  const alias = body.alias?.trim();
  return {
    softwareInvoice: normalizeSoftwareProfile(body.softwareInvoice),
    softwarePos: normalizeSoftwareProfile(body.softwarePos),
    softwarePayroll: normalizeSoftwareProfile(body.softwarePayroll),
    ...(alias ? { alias } : {}),
  };
}
